var $082ceea6fcaba915$exports = {};
$082ceea6fcaba915$exports = {
    "loading": `Loading\u{2026}`,
    "loadingMore": `Loading more\u{2026}`
};


export {$082ceea6fcaba915$exports as default};
//# sourceMappingURL=en-US.mjs.map
